import React from 'react'
import Question from './Question'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import AddQuestionForm from '../containers/AddQuestionForm'
import SubmitHelp from './SubmitHelp'
import SubmitHelpAnonymously from './SubmitHelpAnonymously'
import LGYHubTicket from './LGYHubTicket'

const FAQ = (props) => {
  const { faqCategories, fetching, userCanEditFAQ, success, helpTicketUrlAnonymous, helpTicketUrlLoggedInInternal, helpTicketUrlLoggedInExternal, helpTicketUrlLoggedOutExternal, isCsmEnabled, isCsmEnabledForAnonymousUsers, userIsLoggedIn, userIsAffiliate } = props
  const shouldShowAnonymousCSMLink = isCsmEnabledForAnonymousUsers && !userIsLoggedIn
  const shouldShowLoggedInInternalCSMLink = isCsmEnabled && userIsLoggedIn && !userIsAffiliate 
  const shouldShowLoggedInExternalCSMLink = isCsmEnabled && userIsLoggedIn && userIsAffiliate 
  const shouldLgyHubTicketLink = !shouldShowAnonymousCSMLink && !shouldShowLoggedInExternalCSMLink && !shouldShowLoggedInInternalCSMLink

  return (
  <div className='faq usa-grid'>
    <span className='faq-lgy-help-link'>
      {shouldShowAnonymousCSMLink && 
        <SubmitHelpAnonymously 
          linkExternal={helpTicketUrlLoggedOutExternal} 
          linkAnonymous={helpTicketUrlAnonymous}>
        </SubmitHelpAnonymously>}
      {shouldShowLoggedInExternalCSMLink && <SubmitHelp hyperlink={helpTicketUrlLoggedInExternal} />}
      {shouldShowLoggedInInternalCSMLink && <SubmitHelp hyperlink={helpTicketUrlLoggedInInternal} />}
      {shouldLgyHubTicketLink && <LGYHubTicket hyperlink={helpTicketUrlLoggedInInternal} />}
    </span>

    {success && <div className='faq-alert-dialog'><LgyAlertDialog type='success' heading='FAQ Updated' text='Successfully updated FAQ' /></div>}
    
    <h2>Frequently Asked Questions</h2>

    {(faqCategories && faqCategories.length > 0)
      ? faqCategories.map((category) =>
        category.faqs.length > 0  && <div key={category.id}>
          <h3>{category.description}</h3>
          <ul className='usa-accordion-bordered'>
            {category.faqs.sort((a,b) => a.sortOrder - b.sortOrder).map((question) =>
              <li key={question.id}>
                <Question question={question} categories={faqCategories} userCanEditFAQ={userCanEditFAQ} />
              </li>
            )}
          </ul>
          </div>)
      : fetching
        ? <span>Loading...</span>
        : <span>No questions yet</span>}

    {userCanEditFAQ && (faqCategories && faqCategories.length > 0) && <AddQuestionForm categories={[...faqCategories]} />}

  </div>)
}

export default FAQ